'use strict';

/**
 * Company-defined custom slots (CustomTempSection UD001–UD005) or user-added TempSection
 * rows (sectionNo prefix CS… from addCustomTempSection).
 *
 * Used to bypass advisor/investor/member section gates for sidebar visibility and saves.
 *
 * @param {string|null|undefined} sectionNoOrQNo  Section number or full question qNo
 * @returns {boolean}
 */
export function isCustomTempSectionNo(sectionNoOrQNo) {
    if (sectionNoOrQNo == null || sectionNoOrQNo === '') return false;
    const root = String(sectionNoOrQNo).split('.')[0].trim();
    if (!root) return false;
    if (/^UD00[1-5]$/i.test(root)) return true;
    if (/^CS[A-Z0-9]+$/i.test(root)) return true;
    return false;
}
